import {
  BodyPostStreetviewHouseholdData, GeoJsonFeatureResponse, StreetviewWardDataResponse,
} from '../../api-models';
import { HTTPMethod } from '../../types/enums';
import { SelectedFilters } from '../../types/filters.type';
import {
  AdapterInterface, FrontendGeoJsonFeature, MapHeadlines, StreetviewAreaData,
} from '../../types/global';
import adaptFilterRequest from './adaptFilterRequest';

import BaseAdapter from './baseAdapter';

export default class PostStreetviewWards extends BaseAdapter<StreetviewWardDataResponse> implements AdapterInterface {
  rawResponse: StreetviewWardDataResponse;

  modifiedRequest: BodyPostStreetviewHouseholdData;

  async adaptResponse(request: { data: SelectedFilters, signal: AbortSignal }): Promise<StreetviewAreaData> {
    const formattedRequest = this.adaptRequest(request.data);

    await this.fetchApiResponse('/api/streetview-ward-data', HTTPMethod.Post, formattedRequest, request.signal);
    return this.displayResponse();
  }

  displayResponse(): StreetviewAreaData {
    const mapHeadlines: MapHeadlines[] = this.rawResponse.map_headlines.map((headline) => ({
      displayName: headline.display_name,
      description: headline.description,
      value: headline.value,
    }));

    const geoJsonFeatures: FrontendGeoJsonFeature[] = this.rawResponse.geo_json_features.map((ward: GeoJsonFeatureResponse) => ({
      type: ward.type,
      id: ward.id,
      geometry: ward.geometry,
      properties: {
        name: ward.properties.ward_name,
        longitude: ward.properties.longitude,
        latitude: ward.properties.latitude,
        householdCount: ward.properties.household_count,
      },
    }));

    return { geoJsonFeatures, mapHeadlines };
  }

  adaptRequest(selectedFilters: SelectedFilters): BodyPostStreetviewHouseholdData {
    this.modifiedRequest = adaptFilterRequest(selectedFilters);
    return this.modifiedRequest;
  }
}
